import styled from '@emotion/styled';

export const Wizard = styled.div`
    margin-top: 2rem;
`;
